import { useEffect, useMemo, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { ExternalLink, Eye, Globe2 } from "lucide-react";
import { db } from "../firebase";

const SUPPORT_TEST_EMAIL = "destek@argevio.com";

function TenantPanelAccessView({ themeMode = "light" }) {
  const [tenants, setTenants] = useState([]);
  const [domains, setDomains] = useState([]);
  const [error, setError] = useState("");
  const dark = themeMode === "dark";
  const surface = dark ? "#162133" : "#fff";
  const border = dark ? "#334155" : "#dbe2ea";
  const text = dark ? "#e5edf6" : "#124254";
  const muted = dark ? "#9fb0c4" : "#64748b";

  useEffect(() => {
    const stopTenants = onSnapshot(collection(db, "tenants"),
      (snapshot) => setTenants(snapshot.docs.map((item) => ({ id: item.id, ...item.data() }))),
      (reason) => setError(reason.message));
    const stopDomains = onSnapshot(collection(db, "tenantDomains"),
      (snapshot) => setDomains(snapshot.docs.map((item) => ({ id: item.id, ...item.data() }))),
      (reason) => setError(reason.message));
    return () => { stopTenants(); stopDomains(); };
  }, []);

  const rows = useMemo(() => tenants.map((tenant) => {
    const domain = domains.find((item) => item.tenantId === tenant.id && item.isPrimary !== false) ||
      domains.find((item) => item.tenantId === tenant.id);
    return { ...tenant, hostname: domain?.hostname || domain?.id || `${tenant.slug || tenant.id}.argevio.com` };
  }), [domains, tenants]);

  const openPanel = (hostname, customerView = false) => {
    const url = new URL(`https://${hostname}`);
    if (customerView) {
      url.searchParams.set("argevioView", "customer");
      url.searchParams.set("supportEmail", SUPPORT_TEST_EMAIL);
    }
    window.open(url.toString(), "_blank", "noopener,noreferrer");
  };

  return <div style={{ color: text }}>
    <div style={{ marginBottom: 18 }}><h2 style={{ margin: 0 }}>Müşteri Panelleri</h2><p style={{ color: muted, fontWeight: 750 }}>Tenant alanlarını açın veya müşterinin gördüğü hostname bağlamında destek test hesabıyla işlem yapın.</p><div style={{ marginTop: 9, display: "inline-flex", gap: 7, alignItems: "center", padding: "7px 10px", borderRadius: 999, background: dark ? "#20334a" : "#ecfeff", color: dark ? "#99f6e4" : "#0f766e", fontSize: 12, fontWeight: 850 }}>Test hesabı: {SUPPORT_TEST_EMAIL}</div></div>
    {error && <div style={{ padding: 11, borderRadius: 10, background: "#fee2e2", color: "#991b1b", marginBottom: 12 }}>{error}</div>}
    <div style={{ display: "grid", gap: 12 }}>{rows.map((tenant) => <article key={tenant.id} style={{ background: surface, border: `1px solid ${border}`, borderRadius: 17, padding: 17, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16 }}>
      <div style={{ display: "flex", gap: 12, alignItems: "center" }}><span style={{ width: 42, height: 42, borderRadius: 13, background: dark ? "#20334a" : "#ecfeff", color: "#0f766e", display: "grid", placeItems: "center" }}><Globe2 size={21}/></span><div><strong>{tenant.name || tenant.id}</strong><div style={{ color: muted, fontSize: 13, marginTop: 4 }}>{tenant.hostname}</div><small style={{ color: tenant.status === "active" ? "#0f766e" : muted }}>{tenant.status === "active" ? "Aktif" : tenant.status || "Durum belirtilmemiş"}{tenant.isDemo ? " · Demo" : ""}</small></div></div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", justifyContent: "flex-end" }}><button onClick={() => openPanel(tenant.hostname)} style={secondary}><ExternalLink size={16}/> Paneli aç</button><button onClick={() => openPanel(tenant.hostname, true)} style={primary}><Eye size={16}/> Müşteri gözüyle</button></div>
    </article>)}{!rows.length && <div style={{ padding: 30, textAlign: "center", color: muted }}>Henüz tenant kaydı yok.</div>}</div>
    <div style={{ marginTop: 14, padding: 13, borderRadius: 13, background: dark ? "#20334a" : "#f8fafc", color: muted, fontSize: 13 }}><strong>İzlenebilirlik:</strong> Müşteri gözüyle açılan panelde <strong>{SUPPORT_TEST_EMAIL}</strong> ile giriş yapın. Yapılan işlemler bu kullanıcı adıyla loglanır; müşteri hesabı veya parolası kullanılmaz.</div>
  </div>;
}

const primary = { border: 0, borderRadius: 10, padding: "10px 12px", background: "#0f766e", color: "#fff", fontWeight: 850, display: "inline-flex", alignItems: "center", gap: 6, cursor: "pointer" };
const secondary = { ...primary, background: "#eef4f6", color: "#124254", border: "1px solid #dbe2ea" };
export default TenantPanelAccessView;
